<template>
<div id="haier">
    <Header v-if="showHeader" />
    <router-view/>
</div>
</template>
<script>
import Header from '@/components/common/WebHeader'
export default {
    name: 'Haier',
    components:{ Header },
    data(){
        return {
            showHeader:true
            // notHaierProduct:this.$route.query.bankUrl&&this.$route.query.bankUrl.indexOf('haierProduct.html')==-1//不是官网产品，车链网页面
        }
    },
    created(){
        console.log('this.$route.path ',this.$route.path )
        if(this.$route.path.indexOf('aggrementProtocol')==-1){
            this.showHeader=true
        }else{
            this.showHeader=false
        }
    }
}
</script>
<style lang="less">
	@import "../../assets/index.less";
</style>


// WEBPACK FOOTER //
// src/pages/common/common.vue